





import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { IFeaturesSection, IOffersSection, IOffer, IProduct } from '../../data/model';
import Offer from './offer.vue';
import {TranslatedComponent} from '../translatedComponent';

@Component({ components: {Offer} })
export default class Offers extends Vue {
    @Prop()
    public section!: IOffersSection;
    @Prop()
    public product!: IProduct;

    @Emit('buy-offer-clicked')
    public buy(offer: IOffer) {
        return offer;
    }
}
